import { STEP } from '../../store/orderFlow';
import {
  LocationIcon,
  RentalIcon,
  ConfigIcon,
  ClientIcon,
  DeliveryIcon,
  VerificationIcon
} from '../../components/UI/Icons/RentalRequestIcons';
import { ProductConfigSummary } from '../../components';
import loadable from '@loadable/component';
import React from 'react';

const LocationSelector = loadable(() => import('./sub-components/LocationSelector/LocationSelector'));
const ProductCards = loadable(() => import('./sub-components/ProductCards/ProductCards'));
const RentalClientForm = loadable(() => import('./sub-components/ClientInformation/RentalClientForm'));
const ProductConfigForm = loadable(() => import('./sub-components/ProductConfigForm/ProductConfigForm'));
const DeliveryForm = loadable(() => import('./sub-components/DeliveryForm/DeliveryForm'));
const ProductDropDown = loadable(() => import('./sub-components/ProductDropDown'));
const RentalLayout = loadable(() => import('./sub-components/RentalLayout'));
const Summary = loadable(() => import('./sub-components/Summary/Summary'));

export const STEP_VALUES = Object.values(STEP);

// TODO: ADD COMPONENTS HERE
export const rentalStepperMap = {
  [STEP.LOCATION]: () => {
    return {
      component: <LocationSelector />,
      title: 'Kies een locatie',
      label: 'Locatie',
      icon: <LocationIcon />
    };
  },
  [STEP.PRODUCT_CARDS]: () => {
    return {
      component: <ProductCards />,
      title: 'Kies een huurmiddel',
      label: 'Huurmiddel',
      icon: <RentalIcon />
    };
  },
  [STEP.PRODUCT_CONFIG]: (name) => {
    return {
      component: (
        <RentalLayout>
          <ProductConfigForm />
          <ProductConfigSummary />
        </RentalLayout>
      ),
      title: name,
      label: 'Configuratie',
      icon: <ConfigIcon />
    };
  },
  [STEP.RENTAL_FORM]: () => {
    return {
      component: (
        <RentalLayout>
          <RentalClientForm />
          <ProductDropDown />
        </RentalLayout>
      ),
      title: 'Cliënt gegevens',
      label: 'Cliënt',
      icon: <ClientIcon />
    };
  },
  [STEP.DELIVERY_FORM]: () => {
    return {
      component: (
        <RentalLayout>
          <DeliveryForm />
          <ProductDropDown />
        </RentalLayout>
      ),
      title: 'Bezorging',
      label: 'Bezorging',
      icon: <DeliveryIcon />
    };
  },
  [STEP.SUMMARY]: () => {
    return {
      component: <Summary />,
      title: 'Controleer uw aanvraag',
      label: 'Controleren',
      icon: <VerificationIcon />
    };
  }
};

export const commonMappings = [
  {
    key: "wheelchairWorksheetType",
    dataKey: "wheelchairWorksheetType",
    label: "Type werkbladen:",
  },
];

export const breezyIbisMappings = [
  {
    key: "wheelchairHeadRestType4",
    dataKey: "wheelchairHeadRestType4",
    label: "Hoofdsteun:",
    extra: true,
  },
  {
    key: "wheelchairSittingTypeIbis",
    dataKey: "wheelchairSittingTypeIbis",
    label: "Zitting:",
  },
  {
    key: "wheelchairBackrestTypeIbis",
    dataKey: "wheelchairBackrestTypeIbis",
    label: "Rugleuning:",
  },
  {
    key: "wheelchairLegSupportType2",
    dataKey: "wheelchairLegSupportType2",
    label: "Beenondersteuning:",
  },
];

export const defaultMappings = [
  {
    key: "wheelchairBackrestTypeSelfdrive",
    dataKey: "wheelchairBackrestTypeSelfdrive",
    label: "Rugleuning:",
  },
  {
    key: "wheelchairSittingTypeRevab",
    dataKey: "wheelchairSittingTypeRevab",
    label: "Zitting:",
  },
  {
    key: "wheelchairHeadRestType3",
    dataKey: "wheelchairHeadRestType3",
    label: "Hoofdsteun:",
    extra: true,
  },
  {
    key: "wheelchairHeadRestType2",
    dataKey: "wheelchairHeadRestType2",
    label: "Hoofdsteun:",
    extra: true,
  },
  {
    key: "wheelchairSittingHeightAdjustable",
    dataKey: "wheelchairSittingHeightAdjustable",
    label: "Afstellen op trippelhoogte:",
  },
  {
    key: "wheelchairLegSupportType2",
    dataKey: "wheelchairLegSupportType2",
    label: "Beenondersteuning:",
  },
  {
    key: "wheelchairLeftLegSupportType2",
    dataKey: "wheelchairLeftLegSupportType2",
    label: "Speciale beenondersteuning links:",
  },
  {
    key: "wheelchairRightLegSupportType2",
    dataKey: "wheelchairRightLegSupportType2",
    label: "Speciale beenondersteuning rechts:",
  },
];

export const adMappings = [
  {
    key: "adBoardSeat",
    dataKey: "adBoardSeat",
    label: "Plankzitting benodigd:",
  },
  {
    key: "adPillowRelatedWheelchair",
    dataKey: "adPillowRelatedWheelchair",
    label: "Voorzieningsnummer:",
  },
  {
    key: "adPillowType",
    dataKey: "adPillowType",
    label: "AD zitkussen:",
  },
];